import { t } from "@/i18n-js/instance";

import plusSummaryBoxImage1x from "./assets/plus_summary_box_image@1x.png";
import plusSummaryBoxImage2x from "./assets/plus_summary_box_image@2x.png";
import plusSummaryBoxImage3x from "./assets/plus_summary_box_image@3x.png";

export const PlusPromotionImage = () => (
  <img
    src={plusSummaryBoxImage2x}
    srcSet={`${plusSummaryBoxImage1x} 1x, ${plusSummaryBoxImage2x} 2x, ${plusSummaryBoxImage3x} 3x`}
    alt={t(
      "pricing_plans.plan_settings.plus_plan_summary.illustration.image_alt",
    )}
    className="size-full object-cover"
    loading="lazy"
  />
);
